import { UPLOAD_ENTITY_TYPES } from "constants/documentUploads";

import { UPLOAD_TARGET_CONFIG } from "../../constants";
import { createFlowStrategy } from "./baseFlowStrategy";
import { createCollectionsStrategy } from "./collectionsStrategy";
import { createTemplateStrategy } from "./templateStrategy";

export class UnsupportedUploadTargetError extends Error {
  constructor(target) {
    super(`Unsupported upload target: ${target}`);
    this.name = "UnsupportedUploadTargetError";
  }
}

const {
  COLLECTIONS,
  DOC_STYLE_TEMPLATES,
  FOLDER,
  OPPORTUNITY,
  CONTRACT,
  PROPOSAL,
  MISC_ANALYSIS,
  MISC_ANALYSIS_RESEARCH,
  MISC_ANALYSIS_PROPOSAL_WRITING,
} = UPLOAD_ENTITY_TYPES;

const flowTargets = [
  FOLDER,
  OPPORTUNITY,
  CONTRACT,
  PROPOSAL,
  MISC_ANALYSIS,
  MISC_ANALYSIS_RESEARCH,
  MISC_ANALYSIS_PROPOSAL_WRITING,
];

const buildStrategies = () => {
  const strategies = {
    [COLLECTIONS]: createCollectionsStrategy(UPLOAD_TARGET_CONFIG[COLLECTIONS]),
    [DOC_STYLE_TEMPLATES]: createTemplateStrategy(
      UPLOAD_TARGET_CONFIG[DOC_STYLE_TEMPLATES]
    ),
  };

  // Register a flow strategy only for targets that have a config entry; the rest
  // fail safe via getStrategy rather than crashing on a missing uploadUrl.
  flowTargets.forEach((target) => {
    if (UPLOAD_TARGET_CONFIG[target]) {
      strategies[target] = createFlowStrategy(UPLOAD_TARGET_CONFIG[target]);
    }
  });

  return strategies;
};

const STRATEGIES = buildStrategies();

export const getStrategy = (target) => {
  const strategy = STRATEGIES[target];
  if (!strategy) {
    throw new UnsupportedUploadTargetError(target);
  }
  return strategy;
};
